import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { UserFormData } from 'types/user';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNotifications } from 'hooks/useNotifications';
import { PATH } from 'routes/path';
import { createNewUser } from 'services/userService';
import { UserForm } from 'components/Users/UserForm';
import { ONLY_CONTRACTOR } from 'constants/roles';
import { useDeniedAccess } from 'hooks/useDeniedAccess';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};
export const CreateUserPage = () => {
    const [isLoading, setIsLoading] = useState(false);

    const notifications = useNotifications();
    const navigate = useNavigate();

    const submitHandler = (form: UserFormData) => {
        setIsLoading(true);
        createNewUser(form)
            .then(() => {
                notifications.show({ message: 'User successfully created' });
                navigate(PATH.USERS);
            })
            .finally(() => setIsLoading(false));
    };

    useDeniedAccess(ONLY_CONTRACTOR);

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Create User" sx={cardStyles}>
                <UserForm onSubmit={submitHandler} />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
